import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./Modal.css";

import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

const portalRoot = document.getElementById("portal-root");

type ModalProps = {
  id?: string | undefined,
  onClickClose?: any,
  children?: any,
  videosPosVenda?: [],
  key?: any,
};

const UIModal = ({
  id = "modal",
  children,
  modalIsOpen,
  onClickClose,
  videosPosVenda,
  key,
}: ModalProps) => {
  const handleOutSideClick = (e) => {
    if (e.target.id === id) onClickClose();
  };

  return ReactDOM.createPortal(
    <div id={id} className="ui-modal__overlay" onClick={handleOutSideClick}>
      <div className="ui-modal">
        <button type="button" className="ui-modal__close-button" onClick={onClickClose}>
          X
        </button>
        {children}
      </div>
    </div>,
    portalRoot
  );
};
export default UIModal;
